import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Register from "../pages/Register";
import Login from "../pages/Login";
import NotFound from "../pages/NotFound";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/page/register" element={<Register />} />
      <Route path="/page/login" element={<Login />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
